import connection from '../shared/connection';
import { delay, getOrgChannel } from './utils';
import { NodeManager } from '../core/new_pi/newPinode';
import { throttle } from 'lodash';
import type sharedb from 'sharedb';

export type onListenNameType = 'change';
export type PiConnectionOptionsType = {
  orgDataType: number;
  docId: string;

  /**
   * nodeManager options
   */
  request: any;
  orgId: string;
  userId: string;
  groupList: any;
  role: number;
  rootId: string;
  toBeSortId: string;
  clientType: string;
  loadByLayer: boolean;
  templateList: any[];
  userList: any[];
  dataType: number;
  org_option?: any;
  // 只读模式，不走sharedb 直接parseFromJsonDoc([{0:0}])
  readonly?: boolean;
  userDetailList: any[];
};
/**
 * 连接
 * 空间变化时创建
 *
 *
 */
export class PiConnection {
  private options: PiConnectionOptionsType;
  private orgDataType = 0;
  private docId = '';

  private instance: sharedb.Doc | null = null;
  private connectionStatus: boolean = false;

  // 是否正在执行ParseFromJson
  private isParseFromJsoning: boolean = false;
  // ParseFromJson是否需要再次执行
  private needReParseFormJson: boolean = false;

  // @ts-ignore
  public nodeManager: PiNodeManager;

  /**
   * 节点的展开记录
   * 1. 在expandAll后，不需要再执行任何expand
   * 2. expand不能并发
   */

  private expandMap: Record<string, boolean> = {};
  private expandingNodeId: string | null = null;

  constructor(options: PiConnectionOptionsType) {
    this.orgDataType = options.orgDataType;
    this.docId = options.docId;

    this.options = options;

    /**
     * 恢复可见时，重新开始更新
     */
    document.addEventListener('visibilitychange', this.onVisibilityChange);
  }

  /**
   * 启动连接
   */
  public async connection() {
    if (this.options.readonly) {
      this.onInstanceChange();
      return;
    }

    const throttleChange = throttle(() => {
      this.onInstanceChange();
    }, 1000);

    return new Promise<void>((resolve) => {
      this.instance = connection.get(getOrgChannel(this.orgDataType), this.docId);

      this.instance.subscribe(async () => {
        await this.onInstanceChange();
        resolve();
      });
      this.instance.on('op', throttleChange);
    });
  }

  public onInstanceChange = async () => {
    // TODO
    // 1. 空间不需要响应时 跳过
    // 2. 未激活/断网窗口，恢复时，会依次更新期间内所有change
    if (!this.connectionStatus) {
      this.connectionStatus = true;
    }

    /**
     * 不可见时，不触发更新
     */
    if (document.visibilityState === 'hidden' && this.nodeManager) {
      return;
    }

    const newChangeData = this.options.readonly ? [{ 0: 0 }] : this.instance?.data;
    if (!this.nodeManager) {
      this.nodeManager = new NodeManager(
        this.options.request,
        this.options.orgId,
        this.options.userId,
        this.options.groupList,
        this.options.role,
        this.options.rootId as unknown as null,
        this.options.toBeSortId as unknown as null,
        this.options.clientType,
        this.options.loadByLayer,
        this.options.templateList,
        this.options.userList,
        this.options.dataType,
        this.options.org_option,
        this.options.userDetailList,
      ) as unknown as PiNodeManager;
    }

    // 正在parseForm时， 标记needReParseFormJson，跳过更新
    if (this.isParseFromJsoning) {
      this.needReParseFormJson = true;
      return;
    }

    this.isParseFromJsoning = true;
    await this.nodeManager.parseFromJsonDoc(newChangeData);
    console.log('onInstanceChange', this.options.orgId);
    this.isParseFromJsoning = false;

    if (this.needReParseFormJson) {
      this.needReParseFormJson = false;
      this.onInstanceChange();
    }
  };

  public async expandTo(nodeId: string, forceExpand?: boolean): Promise<any> {
    // 已加载全部节点后，不需要再加载单个节点
    if (this.expandMap.all) {
      return;
    }

    // 已加载直接返回
    if (this.expandMap[nodeId]) {
      return;
    }

    // 有节点在加载中， 等待重试
    if (this.expandingNodeId !== null) {
      await delay(500);
      return await this.expandTo(nodeId);
    }

    // 加载节点
    this.expandingNodeId = nodeId;
    if (nodeId === 'all') {
      this.classConsole('expandAll');
      await this.nodeManager.expandAll();
    } else {
      if (forceExpand) {
        this.classConsole('expand', nodeId);
        await this.nodeManager.expand(nodeId);
      } else {
        this.classConsole('expandTo', nodeId);
        await this.nodeManager.expandTo(nodeId);
      }
    }
    this.classConsole('expand end', nodeId);
    this.expandMap[nodeId] = true;
    this.expandingNodeId = null;
  }
  /**
   * 获取节点是否已加载
   */
  public isExpand(nodeId: string): boolean {
    if (this.expandMap.all) {
      return true;
    }
    return this.expandMap[nodeId];
  }
  /**
   * 展开所有
   */
  public async expandAll() {
    await this.expandTo('all');
  }

  /**
   * 关闭连接
   */
  public async destroy() {
    document.removeEventListener('visibilitychange', this.onVisibilityChange);

    if (this.instance) {
      await this.instance.destroy();
      this.instance = null;
    }
  }

  private onVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      this.onInstanceChange();
      return;
    }
  };

  private classConsole(...arg: any) {
    if (window.location.host !== 'mylinkpi.com') {
      console.log('%c[piConnection]', 'color:blue', arg);
    }
  }
}
